
import React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Popover,
  Popper,
  TextField,
  Select,
} from "@mui/material";

const ProcessSettings = ({
  data = {
    reviewSource: null, // Review source data, currently set to null
    setReviewSource: null, // Function to set the review source
    steps: null, // Steps data, currently set to null
    setSteps: null, // Function to set the steps
    count: null, // Count data, currently set to null
    setCount: null, // Function to set the count
    saveSteps: false, // Save steps flag, initially set to false
    setSaveSteps: null, // Function to set the save steps flag
    overWriteTopics: false, // Overwrite topics flag, initially set to false
    setOverWriteTopics: null, // Function to set the overwrite topics flag
  },
  open = false, // Flag to determine if the menu is open, initially set to false
  onClose = null, // Function to be called when the menu is closed
  anchorEl = null, // Anchor element to position the menu
}) => {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  // Return the Menu component
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <div style={{ width: "370px" }}>
        <Grid container spacing={1} sx={{ p: 2 }} columns={12} rowSpacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>Get Reviews</InputLabel>
              <Select label="Get Reviews" value={data.reviewSource} onChange={e => data.setReviewSource(e.target.value)}>
                <MenuItem value={1}>From UI</MenuItem>
                <MenuItem value={2}>From DB</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>Steps</InputLabel>
              <Select label="Steps" value={data.steps} disabled={data.reviewSource === 1} onChange={e => data.setSteps(e.target.value)}>
                <MenuItem value={1}>All Steps</MenuItem>
                <MenuItem value={2}>Step 1</MenuItem>
                <MenuItem value={3}>Step 2</MenuItem>
                <MenuItem value={4}>Step 3</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              size="small"
              type='number'
              label="Count"
              variant="outlined"
              disabled={data.reviewSource === 1}
              inputProps={{ sx: { width: 70 } }}
              sx={{ mr: 2 }}
              value={data.count ?? 0}
              onChange={(e) => data.setCount(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  sx={{ py: 0, lh: 0.5 }}
                  checked={data?.saveSteps}
                  // disabled={true}
                  onChange={(e) =>
                    data.setSaveSteps(e.target.checked)
                  }
                />
              }
              label="Save Output"
            />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  sx={{ py: 0, lh: 0.5 }}
                  checked={data?.overWriteTopics}
                  disabled={!data?.saveSteps}
                  onChange={(e) =>
                    data.setOverWriteTopics(e.target.checked)
                  }
                />
              }
              label="Overwrite Topics"
            />
          </Grid>
        </Grid>
      </div>
    </Popover>
  );
};

export default ProcessSettings;
